import Extractor from './extractor.js';

class Images extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    result['src'] = this.getData(
      [
        {instance: data, object:'place', property: 'image'},        
        {instance: data, object:'webpage', property: 'image'},        
        {instance: data, object:'cse_image', property: 'src'},        
        {instance: data, object:'metatags', property: 'og:image'},        
        {instance: data, object:'cse_thumbnail', property: 'src'},        
      ], null);

    if(result['src'] && result['src'] !== null){
      if(result['src'].includes(":80/")){
        result['src'] = result['src'].replace(":80/", "/");
      }

      if(result['src'].includes("fbsbx.com")){
        delete result['src'];
      }      
    }

    result['src_https'] = this.getData(
      [
        {instance: data, object:'metatags', property: 'og:image:https'},        
      ], null);

    result['name'] = this.getData(
      [
        {instance: data, object:'place', property: 'name'},        
      ], "-");

    result['alt'] = (result['src']) ? result['src'] : 'none';

    result['description'] = this.getData(
      [
        {instance: data, object:'place', property: 'description'},        
      ], null);

    result['height'] = this.getData(
      [
        {instance: data, object:'metatags', property: 'og:image:height'},        
        {instance: data, object:'cse_thumbnail', property: 'height'}, 
        {instance: data, object:'cse_image', property: 'height'},               
      ], 1);

    result['width'] = this.getData(
      [
        {instance: data, object:'metatags', property: 'og:image:width'},        
        {instance: data, object:'cse_thumbnail', property: 'width'},   
        {instance: data, object:'cse_image', property: 'width'},             
      ], 1);

    result['has_data'] = (data && !data.videoobject && result['src']) ? 1 : 0;

    return result;
  }
}

export default (Images);


// WEBPACK FOOTER //
// ./src/search/extractor/image.js